// import $api from "../../common/api";
import router from '@/router';
import Home from '@/views/Home.vue';
import indexApi from '@/api/cloud';

const permission = {
  state: {
    addRouters: [], //过滤后的路由数据
    sideRouter: [], //侧边栏数据

    limitsData: [], //单页权限数据
  },

  getters: {
    // 清空路由
    cleanRouter(state) {
      state.addRouters = [];
      state.sideRouter = [];
    },

    // 返回侧边栏菜单数据
    getSideRouter(state) {
      return state.sideRouter;
    },

    // 返回路由数据
    getAddRouter(state) {
      return state.addRouters;
    },

    // 判断路由是否有数据
    routersLength(state) {
      return state.sideRouter.length;
    },

    // 返回权限数据
    getLimitsData(state) {
      return state.limitsData;
    },
  },

  mutations: {
    // 储存过滤后路由数据
    saveAddRouter(state, data) {
      state.addRouters = data;
    },

    // 储存侧边路由数据
    saveSideRouter(state, data) {
      state.sideRouter = data;
    },

    // 储存权限数据
    saveLimitsData(state, data) {
      state.limitsData = data;
    },
  },

  actions: {
    // 获取路由，动态添加
    loadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        indexApi
          .getAuthMenu({
            appid: localStorage.getItem('app') ? JSON.parse(localStorage.getItem('app')).appid : '',
          })
          .then(res => {
            //接口获取
            if (res.data.length) {
              commit('saveAddRouter', []);
              commit('saveSideRouter', []);
              const getRouter = JSON.parse(JSON.stringify(res.data));
              const rewriteRoutes = routerFilter(getRouter); //将接口获取的数据转换成router组件对象
              router.addRoute({
                path: '/',
                redirect: rewriteRoutes.children[0].path,
              }); //添加重定向
              // rewriteRoutes.redirect = rewriteRoutes.children[0].path
              router.addRoute(rewriteRoutes); // 动态添加可访问路由表
              commit('saveAddRouter', rewriteRoutes);
              commit('saveSideRouter', getRouter);
              resolve(rewriteRoutes.children[0].path);
            } else {
              reject();
            }
          });
      });
    },
  },
};

// 其他本地路由
let elseRouter = [
  {
    path: '/editAgreement',
    meta: {
      title: '编辑协议',
    },
    component: () => import('@/views/cloud/config/editAgreement.vue'),
  },
  {
    path: '/cloud/decor',
    meta: {
      title: '页面模板',
    },
    component: () => import('@/views/cloud/dec/decor.vue'),
  },
  // {
  //   path: '/cloud/tool/quetionList',
  //   meta: {
  //     title: '题目管理',
  //   },
  //   component: () => import('@/views/cloud/tool/quetionList.vue'),
  // },
  {
    path: '/bottomTabbar',
    meta: {
      title: '菜单编辑',
    },
    component: () => import('@/views/cloud/dec/bottomTabbar.vue'),
  },
  {
    path: '/cloud/sys/changePwd',
    meta: {
      title: '修改密码',
    },
    component: () => import('@/views/cloud/sys/changePwd.vue'),
  },
  {
    path: '/pms/landlord/lockPreCheck',
    meta: {
      title: '锁具预审',
    },
    component: () => import('@/views/pms/landlord/lockPreCheck.vue'),
  },
];

// 将接口获取的数据转换成router组件对象
const routerFilter = menuData => {
  let newRouter = {
    path: '/',
    name: 'Home',
    component: Home,
    children: [],
  };
  let children = [];
  menuData.forEach(itemRouter => {
    if (itemRouter.child && itemRouter.child.length) {
      itemRouter.child.forEach(itemChild => {
        children.push({
          path: `${itemChild.url}`,
          name: itemChild.url,
          meta: {
            title: itemChild.title,
          },
          component: () => import(`@/views${itemChild.url}`),
        });
      });
    }
  });
  // 添加其他路由
  elseRouter.map(item => {
    children.push(item);
  });
  newRouter.children = children;
  return newRouter;
};

export default permission;
